var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NgModule } from 'angular-ts-decorators';
import { ConnectEmailInboxController } from './email-inbox-connection.controller';
import 'angular';
let EmailInboxConnectionModule = class EmailInboxConnectionModule {
};
EmailInboxConnectionModule = __decorate([
    NgModule({
        id: 'EmailInboxConnectionModule',
        imports: [],
        declarations: [ConnectEmailInboxController],
        providers: [],
    })
], EmailInboxConnectionModule);
export { EmailInboxConnectionModule };
// Required, because we wanna use this controller via 'ng-controller="ConnectEmailInboxController as main" in our HTML,
// otherwise the controller is not known by name:
EmailInboxConnectionModule.module.controller('ConnectEmailInboxController', ConnectEmailInboxController);
